// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.emXTRZMtb6HfaHn9DIjw[data-has-many='true'][data-view='multi'] {
  gap: var(--campaign-header-gap-has-many-multi-desktop);
}
.Jwv53ZzE0v1MPcXwi78G[data-has-many][data-collapsed='false'][data-view][data-variant='card'] {
  margin-bottom: -4px;
}
.Jwv53ZzE0v1MPcXwi78G[data-has-many='false'][data-collapsed='true'] {
  gap: 9px;
}
.Jwv53ZzE0v1MPcXwi78G[data-has-many='true'][data-view='single'] {
  gap: 8px;
}
.Jwv53ZzE0v1MPcXwi78G[data-has-many='true'][data-view='multi'] {
  gap: 11px;
}
.Jwv53ZzE0v1MPcXwi78G[data-has-many='true'][data-collapsed='true'] {
  gap: 10px;
}
.gcJifDFcNKY6fomH3dhA[data-collapsed='true'] > * {
  animation: none;
  opacity: 1;
  margin-top: 0;
}
.UG7Tgq1FiwXgZlVxpajy[data-has-many='false'][data-view='single'] {
  display: none;
}
.ZmAmikeO2BF30Zgy0NsA {
  display: flex;
  align-items: flex-end;
  justify-content: center;
  width: 100%;
  height: 75px;
}
.ZmAmikeO2BF30Zgy0NsA[data-has-many='true'] {
  height: 55px;
  margin-bottom: 0;
}
@media (min-width: 1025px) and (orientation: landscape) {
  .BatuwRKprJEriHzmY7vb[data-has-many='true'][data-collapsed='false'] {
    font-size: var(--campaign-title-font-has-many-expanded-desktop);
  }
  .BatuwRKprJEriHzmY7vb[data-has-many='true'][data-collapsed='true'] {
    font-size: var(--campaign-title-font-has-many-collapsed-desktop);
  }
  .BatuwRKprJEriHzmY7vb[data-has-many='true'][data-collapsed='false'][data-view='multi'] {
    font-size: var(--campaign-title-font-has-many-multi-desktop);
  }
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
  .emXTRZMtb6HfaHn9DIjw[data-has-many='true'][data-view='multi'] {
    gap: var(--campaign-header-gap-has-many-multi-mobile);
  }
  .Jwv53ZzE0v1MPcXwi78G[data-has-many][data-collapsed='false'][data-view][data-variant='card'] {
    margin-bottom: 0;
  }
  .Jwv53ZzE0v1MPcXwi78G[data-has-many][data-collapsed] {
    gap: 5.5px;
  }
  .Jwv53ZzE0v1MPcXwi78G[data-has-many][data-collapsed='true'] {
    gap: 6px;
  }
  .Jwv53ZzE0v1MPcXwi78G[data-has-many='true'][data-collapsed='false'] {
    gap: 4px;
  }
  .Jwv53ZzE0v1MPcXwi78G[data-has-many='true'][data-collapsed='false'][data-view='multi'] {
    gap: 6px;
  }
  .Jwv53ZzE0v1MPcXwi78G[data-has-many='true'][data-collapsed='true'][data-view] {
    gap: 6.5px;
  }
  .ZmAmikeO2BF30Zgy0NsA {
    height: 41px;
  }
  .ZmAmikeO2BF30Zgy0NsA[data-has-many='true'] {
    height: 37px;
    margin-bottom: 1px;
  }
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
@media (max-color:2147477350) and (orientation: landscape) {
  .emXTRZMtb6HfaHn9DIjw[data-has-many='true'][data-view='multi'] {
    gap: var(--campaign-header-gap-has-many-multi-landscape);
  }
  .Jwv53ZzE0v1MPcXwi78G[data-has-many='true'][data-collapsed='false'][data-view='multi'] {
    gap: 7px;
  }
  .BatuwRKprJEriHzmY7vb[data-has-many='true'][data-collapsed='false'][data-view='multi'] {
    font-size: var(--campaign-title-font-has-many-multi-landscape);
  }
}
}
@media not all and (orientation: portrait) {
@media not all and ( (min-width: 768px) and (max-width: 1024px) and (orientation: landscape)) {
@media not all and (max-width: 1024px) {
@media (color:2147477350) and (orientation: landscape) {
  .emXTRZMtb6HfaHn9DIjw[data-has-many='true'][data-view='multi'] {
    gap: var(--campaign-header-gap-has-many-multi-landscape);
  }
  .Jwv53ZzE0v1MPcXwi78G[data-has-many='true'][data-collapsed='false'][data-view='multi'] {
    gap: 7px;
  }
  .BatuwRKprJEriHzmY7vb[data-has-many='true'][data-collapsed='false'][data-view='multi'] {
    font-size: var(--campaign-title-font-has-many-multi-landscape);
  }
}
}
}
}
`, "",{"version":3,"sources":["webpack://./src/features/campaigns/components/variants/rebate/RebateCard/RebateCard.module.css"],"names":[],"mappings":"AAAA;EACE,sDAAsD;AACxD;AACA;EACE,mBAAmB;AACrB;AACA;EACE,QAAQ;AACV;AACA;EACE,QAAQ;AACV;AACA;EACE,SAAS;AACX;AACA;EACE,SAAS;AACX;AACA;EACE,eAAe;EACf,UAAU;EACV,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;AACA;EACE,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE;IACE,+DAA+D;EACjE;EACA;IACE,gEAAgE;EAClE;EACA;IACE,4DAA4D;EAC9D;AACF;AACA;EACE;IACE,qDAAqD;EACvD;EACA;IACE,gBAAgB;EAClB;EACA;IACE,UAAU;EACZ;EACA;IACE,QAAQ;EACV;EACA;IACE,QAAQ;EACV;EACA;IACE,QAAQ;EACV;EACA;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;IACZ,kBAAkB;EACpB;AACF;AACA;AAAA;EACE;IACE,wDAAwD;EAC1D;EACA;IACE,QAAQ;EACV;EACA;IACE,8DAA8D;EAChE;AACF;AAAA;AAVA;AAAA;AAAA;AAAA;EACE;IACE,wDAAwD;EAC1D;EACA;IACE,QAAQ;EACV;EACA;IACE,8DAA8D;EAChE;AACF;AAAA;AAAA;AAAA","sourcesContent":[".campaignCardContainer[data-has-many='true'][data-view='multi'] {\n  gap: var(--campaign-header-gap-has-many-multi-desktop);\n}\n.namePrizeWrapper[data-has-many][data-collapsed='false'][data-view][data-variant='card'] {\n  margin-bottom: -4px;\n}\n.namePrizeWrapper[data-has-many='false'][data-collapsed='true'] {\n  gap: 9px;\n}\n.namePrizeWrapper[data-has-many='true'][data-view='single'] {\n  gap: 8px;\n}\n.namePrizeWrapper[data-has-many='true'][data-view='multi'] {\n  gap: 11px;\n}\n.namePrizeWrapper[data-has-many='true'][data-collapsed='true'] {\n  gap: 10px;\n}\n.campaignTitleCollapsed[data-collapsed='true'] > * {\n  animation: none;\n  opacity: 1;\n  margin-top: 0;\n}\n.separator[data-has-many='false'][data-view='single'] {\n  display: none;\n}\n.progressBarWrapper {\n  display: flex;\n  align-items: flex-end;\n  justify-content: center;\n  width: 100%;\n  height: 75px;\n}\n.progressBarWrapper[data-has-many='true'] {\n  height: 55px;\n  margin-bottom: 0;\n}\n@media (min-width: 1025px) and (orientation: landscape) {\n  .campaignTitleContainer[data-has-many='true'][data-collapsed='false'] {\n    font-size: var(--campaign-title-font-has-many-expanded-desktop);\n  }\n  .campaignTitleContainer[data-has-many='true'][data-collapsed='true'] {\n    font-size: var(--campaign-title-font-has-many-collapsed-desktop);\n  }\n  .campaignTitleContainer[data-has-many='true'][data-collapsed='false'][data-view='multi'] {\n    font-size: var(--campaign-title-font-has-many-multi-desktop);\n  }\n}\n@media (--campaign-mobile) {\n  .campaignCardContainer[data-has-many='true'][data-view='multi'] {\n    gap: var(--campaign-header-gap-has-many-multi-mobile);\n  }\n  .namePrizeWrapper[data-has-many][data-collapsed='false'][data-view][data-variant='card'] {\n    margin-bottom: 0;\n  }\n  .namePrizeWrapper[data-has-many][data-collapsed] {\n    gap: 5.5px;\n  }\n  .namePrizeWrapper[data-has-many][data-collapsed='true'] {\n    gap: 6px;\n  }\n  .namePrizeWrapper[data-has-many='true'][data-collapsed='false'] {\n    gap: 4px;\n  }\n  .namePrizeWrapper[data-has-many='true'][data-collapsed='false'][data-view='multi'] {\n    gap: 6px;\n  }\n  .namePrizeWrapper[data-has-many='true'][data-collapsed='true'][data-view] {\n    gap: 6.5px;\n  }\n  .progressBarWrapper {\n    height: 41px;\n  }\n  .progressBarWrapper[data-has-many='true'] {\n    height: 37px;\n    margin-bottom: 1px;\n  }\n}\n@media (--campaign-mobile) and (orientation: landscape) {\n  .campaignCardContainer[data-has-many='true'][data-view='multi'] {\n    gap: var(--campaign-header-gap-has-many-multi-landscape);\n  }\n  .namePrizeWrapper[data-has-many='true'][data-collapsed='false'][data-view='multi'] {\n    gap: 7px;\n  }\n  .campaignTitleContainer[data-has-many='true'][data-collapsed='false'][data-view='multi'] {\n    font-size: var(--campaign-title-font-has-many-multi-landscape);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"campaignCardContainer": `emXTRZMtb6HfaHn9DIjw`,
	"namePrizeWrapper": `Jwv53ZzE0v1MPcXwi78G`,
	"campaignTitleCollapsed": `gcJifDFcNKY6fomH3dhA`,
	"separator": `UG7Tgq1FiwXgZlVxpajy`,
	"progressBarWrapper": `ZmAmikeO2BF30Zgy0NsA`,
	"campaignTitleContainer": `BatuwRKprJEriHzmY7vb`
};
export default ___CSS_LOADER_EXPORT___;
